/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyChoiceRequest
 */
export interface CompanyChoiceRequest {
    /**
     * The ID of the company to join.
     * @type {string}
     * @memberof CompanyChoiceRequest
     */
    idOfCompanyToJoin: string;
}

/**
 * Check if a given object implements the CompanyChoiceRequest interface.
 */
export function instanceOfCompanyChoiceRequest(value: object): value is CompanyChoiceRequest {
    if (!('idOfCompanyToJoin' in value) || value['idOfCompanyToJoin'] === undefined) return false;
    return true;
}

export function CompanyChoiceRequestFromJSON(json: any): CompanyChoiceRequest {
    return CompanyChoiceRequestFromJSONTyped(json, false);
}

export function CompanyChoiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyChoiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'idOfCompanyToJoin': json['idOfCompanyToJoin'],
    };
}

export function CompanyChoiceRequestToJSON(value?: CompanyChoiceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'idOfCompanyToJoin': value['idOfCompanyToJoin'],
    };
}

